export {default} from './JumboContentLayoutFooter';